module.exports = __webpack_public_path__ + "static/media/banner-img.37643f5b.png";